// extracted by mini-css-extract-plugin
export default {"button":"uploadButton_button__nH1k+"};